<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-green" sprite="call-2" />
          Call Campaigns
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-green" sprite="call-2" />
            Call Campaigns
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>
      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable> </el-input>
          <el-button class="ml-10 hidden-xs-only" @click="doExport">
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-dropdown>
            <el-button>
              Add New
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openCreate('voice')">
                <v-svg class="success-text" sprite="telephone-2" />
                Voice
              </el-dropdown-item>
<!--              <el-dropdown-item @click.native="openCreate('sms')">
                <v-svg class="voxo-orange" sprite="fax-2" />
                SMS
              </el-dropdown-item>-->
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <!-- ⭐ CREATE FORM ⭐ -->
    <create-form
      :createVisible="createVisible"
      :createProcessing="createProcessing"
      :uploadCSVKey="uploadCSVKey"
      :techType="techType"
      :phoneNumberOpts="phoneNumberOpts"
      :clearFormFields="clearFormFields"
      :draggableDestTypes="draggableDestTypes"
      :timezoneOpts="timezoneOpts"
      @remoteSearchPhoneNumbers="remoteSearchPhoneNumbers"
      @createOperation="createOperation"
      @cancelOperation="cancelOperation"
    />

    <!-- ⭐ EDIT FORM ⭐ -->
    <edit-form
      :editVisible="editVisible"
      :editProcessing="editProcessing"
      :key="uploadCSVKey"
      :phoneNumberOpts="phoneNumberOpts"
      :clearFormFields="clearFormFields"
      :draggableDestTypes="draggableDestTypes"
      :timezoneOpts="timezoneOpts"
      :selectedCallCampaign="selectedCallCampaign"
      @remoteSearchPhoneNumbers="remoteSearchPhoneNumbers"
      @editOperation="editOperation"
      @cancelOperation="cancelOperation"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { debounce } from "lodash";
import feathersClient from "../../../feathers/feathers-client";
import createForm from "./components/createForm.vue";
import editForm from "./components/editForm.vue";
import { globalEventBus } from "../../../globalEventBus";
import { ExportToCsv } from "export-to-csv";

export default {
  name: "CallCampaignsTable",

  components: { createForm, editForm },

  data() {
    return {
      uploadCSVKey: null,
      callCampaignChannel: null,
      tableData: [],
      allCallCampaigns: [],
      search: "",
      visibleActionsId: "",

      createVisible: false,
      createProcessing: false,
      editVisible: false,
      editProcessing: false,
      tableLoading: false,

      techType: "",
      phoneNumberOpts: [],
      timezoneOpts: [],
      phoneNumberQuery: null,
      selectedCallCampaign: null,
      total: 0,

      clearFormFields: false,

      draggableDestTypes: [
        "SPECIAL",
        "CUSTOM",
        "IVR",
        "VOICEMAIL",
        "PLAYBACK",
        "HUNTLIST",
        "EXT",
        "QUEUE",
        "SMS",
        "MUSICONHOLD",
        "CONDITION",
      ],

      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: () => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-green" sprite="call-2" />
                </div>
              ];
            }
          }
        },
        {
          field: "name",
          title: "Name",
          minWidth: 120,
          sortable: true,
          showOverflow: true
        },
        {
          field: "type",
          title: "Type",
          minWidth: 100,
          sortable: true,
          showOverflow: true
        },
        {
          field: "tech",
          title: "Tech",
          minWidth: 50,
          sortable: true,
          showOverflow: true
        },
        {
          field: "state",
          title: "State",
          minWidth: 150,
          sortable: true,
          showOverflow: true
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={"edit-" + row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={"delete-" + row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                </div>
              ];
            }
          }
        }
      ]
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {
    selectedTenant() {
      this.findCallCampaigns();
      feathersClient
        .service("channel-memberships")
        .remove(null, { query: { channelName: this.callCampaignChannel } });
      this.joinSocketChannel();
    },

    user() {
      this.findCallCampaigns();
      if (!this.callCampaignChannel) {
        this.joinSocketChannel();
      }
    },

    search: debounce(function() {
      this.searchCallCampaigns();
    }, 500),

    phoneNumberQuery: debounce(function() {
      this.findPhoneNumbers(this.phoneNumberQuery);
    }, 500)
  },

  methods: {
    ...mapActions("campaigns", {
      deleteCallCampaigns: "remove"
    }),

    doExport() {
      const data = [...this.tableData];
      if (data.length) {
        const writeData = data.map(item => ({
          name: item.name,
          type: item.type,
          tech: item.tech,
          state: item.state
        }));

        const options = {
          filename: "call_campaigns",
          showLabels: true,
          headers: ["Name", "Type", "Tech", "State"]
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },

    searchCallCampaigns() {
      if (this.search.length) {
        this.tableData = this.allCallCampaigns.filter(
          data =>
            data.name
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            data.type.toLowerCase().includes(this.search.toLowerCase()) ||
            data.tech.toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        this.tableData = [...this.allCallCampaigns];
      }
      this.total = this.tableData.length;
    },

    remoteSearchPhoneNumbers(query) {
      this.phoneNumberQuery = query;
    },

    //General Form and Table Operations
    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    openCreate(tech) {
      this.clearFormFields = false;
      this.changeUploadCSVKey();
      this.createVisible = true;
      this.techType = tech;
    },

    openEditModal(id) {
      this.changeUploadCSVKey();
      this.clearFormFields = false;
      feathersClient
        .service("campaigns")
        .get(id)
        .then(res => {
          this.selectedCallCampaign = res;
          this.editVisible = true;
        });
    },

    findCallCampaigns() {
      this.tableData = [];
      feathersClient
        .service("campaigns")
        .find({
          query: {
            tenantId: this.selectedTenant.id
          }
        })
        .then(res => {
          this.tableData = [...res];
          this.allCallCampaigns = [...res];
          this.total = res.length;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    findPhoneNumbers(query) {
      const queryParams = {
        tenantId: this.selectedTenant.id,
        $limit: 10,
        $sort: { number: 1 }
      };

      if (query && query.length) {
        const searchTerm = (query + "")
          .replace(/[\\"']/g, "\\$&")
          .replace(/\u0000/g, "\\0");

        queryParams.$or = [{ number: { $like: `%${searchTerm}%` } }];
      }

      feathersClient
        .service("dids")
        .find({
          query: queryParams
        })
        .then(res => {
          this.phoneNumberOpts = [...res];
        });
    },

    createOperation(createBody) {
      this.$confirm("Process call campaign create?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.createProcessing = true;
          feathersClient
            .service("campaigns")
            .create(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Created successfully!",
                type: "success"
              });
              this.cancelOperation("create");
              this.createProcessing = false;
            })
            .catch(error => {
              this.clearFormFields = false;
              this.createProcessing = false;
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
            });
        })
        .catch(() => true);
    },

    editOperation(editBody) {
      this.$confirm("Process call campaign edit?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.editProcessing = true;
          feathersClient
            .service("campaigns")
            .patch(this.selectedCallCampaign.id, editBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited successfully!",
                type: "success"
              });
              this.cancelOperation("edit");
              this.editProcessing = false;
            })
            .catch(error => {
              this.clearFormFields = false;
              this.editProcessing = false;
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
            });
        })
        .catch(() => true);
    },

    deleteOperation(id) {
      this.$confirm("Process call campaign delete?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.tableLoading = true;
          this.deleteCallCampaigns(id)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success"
              });
              this.tableLoading = false;
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.tableLoading = false;
            });
        })
        .catch(() => true);
    },

    cancelOperation(type) {
      this.changeUploadCSVKey();
      this.clearFormFields = true;
      if (type === "create") {
        this.createVisible = false;
      } else if (type === "edit") {
        this.editVisible = false;
      }
    },

    joinSocketChannel() {
      const channelService = feathersClient.service("channel-memberships");
      const data = {
        roomType: "admins",
        tenantId: this.selectedTenant.id
      };
      channelService.create(data).then(res => {
        this.callCampaignChannel = `${data.roomType}/${data.tenantId}`;
      });
    },

    fetchTimezoneOpts() {
      feathersClient
        .service("timezones")
        .find({
          query: {
            $sort: {
              description: 1
            }
          }
        })
        .then(res => {
          this.timezoneOpts = [...res];
        });
    },

    removeListeners() {
      feathersClient.service("campaigns").removeListener("patched");
      feathersClient.service("campaigns").removeListener("created");
      feathersClient.service("campaigns").removeListener("removed");
      globalEventBus.$off("appReconnected");
    },

    getRandomKey() {
      const randomString = () =>
        Math.random()
          .toString(36)
          .slice(2);
      return `${randomString()}-${randomString()}$${randomString()}`;
    },

    changeUploadCSVKey() {
      this.uploadCSVKey = this.getRandomKey();
    }
  },

  created() {
    this.changeUploadCSVKey();

    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on("appReconnected", () => {
      this.joinSocketChannel();
    });

    //record was edited
    feathersClient.service("campaigns").on("patched", data => {
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allCallCampaigns.findIndex(
        item => item.id === data.id
      );
      if (updateIndex >= 0) {
        this.tableData.splice(updateIndex, 1, data);
      }
      if (updateAllIndex >= 0) {
        this.allCallCampaigns.splice(updateAllIndex, 1, data);
      }
    });

    //record was created
    feathersClient.service("campaigns").on("created", data => {
      this.tableData.push(data);
      this.allCallCampaigns.push(data);
    });

    //record was deleted
    feathersClient.service("campaigns").on("removed", data => {
      const indexToRemove = this.tableData.findIndex(
        item => item.id === data.id
      );
      const indexAllToRemove = this.allCallCampaigns.findIndex(
        item => item.id === data.id
      );
      if (indexToRemove >= 0) {
        this.tableData.splice(indexToRemove, 1);
      }
      if (indexAllToRemove >= 0) {
        this.allCallCampaigns.splice(indexAllToRemove, 1);
      }
    });
  },

  mounted() {
    if (this.user) {
      this.findCallCampaigns();
      this.findPhoneNumbers();
      this.joinSocketChannel();
      this.fetchTimezoneOpts();
    }
  },

  beforeDestroy() {
    this.removeListeners();
    feathersClient
      .service("channel-memberships")
      .remove(null, { query: { channelName: this.callCampaignChannel } });
  }
};
</script>
